export enum AddressFormats {
  FULL_SINGLE_LINE = 'fullSingleLine',
  FULL_TWO_LINES = 'fullTwoLines',
  LINE_ONE = 'lineOne',
  LINE_TWO = 'lineTwo'
}
